module.exports = __webpack_public_path__ + "img/pr-2.449a6eab.png";